// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "client-editor/" + ({"396":"TabsFilterDeprecated","404":"TagsFilter","405":"TabsFilter","557":"DropdownFilter","586":"wix-bookings-services-preferences-modal","590":"TagsFilterDeprecated","987":"DropdownFilterDeprecated"}[chunkId] || chunkId) + ".chunk.min.css";
};